define('responsive-gameday-footer/responsive-gameday-footer',['require','./src/js/GamedayFooter'],function(require) {
    return require('./src/js/GamedayFooter');
});

